(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('external-resource.run', {
            parent: 'external-resource',
            url: '/{id}/run',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/external-resource/external-resource-run-dialog.html',
                    controller: 'ExternalResourceRunController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExternalResource', function(ExternalResource) {
                            return ExternalResource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('external-resource', null, { reload: 'external-resource' });
                }, function() {
                    $state.go('^');
                });
            }]
        });

    }

})();
